import { AIDA } from 'src/assets/icons/cards/AIDA';
import { AmazonProductListing } from 'src/assets/icons/cards/AmazonProductListing';
import { Article } from 'src/assets/icons/cards/Article';
import { BlogPostTopicIdes } from 'src/assets/icons/cards/BlogPostTopicIdes';
import { BlogWizard } from 'src/assets/icons/cards/BlogWizard';
import { ContentImprover } from 'src/assets/icons/cards/ContentImprover';
import { Email } from 'src/assets/icons/cards/Email';
import { EmailSubjectLine } from 'src/assets/icons/cards/EmailSubjectLine';
import { FacebookAd } from 'src/assets/icons/cards/FacebookAd';
import { FacebookPost } from 'src/assets/icons/cards/FacebookPost';
import { FifthGrader } from 'src/assets/icons/cards/FifthGrader';
import { GeneralProductListing } from 'src/assets/icons/cards/GeneralProductListing';
import { GoogleRSA } from 'src/assets/icons/cards/GoogleRSA';
import { GoogleSearchAdDescription } from 'src/assets/icons/cards/GoogleSearchAdDescription';
import { GoogleSearchHeadline } from 'src/assets/icons/cards/GoogleSearchHeadline';
import { ImageWithDescription } from 'src/assets/icons/cards/ImageWithDescription';
import { InstagramCaption } from 'src/assets/icons/cards/InstagramCaption';
import { LandingPageBenefits } from 'src/assets/icons/cards/LandingPageBenefits';
import { LandingPageCTA } from 'src/assets/icons/cards/LandingPageCTA';
import { LandingPageFeatures } from 'src/assets/icons/cards/LandingPageFeatures';
import { LandingPageHeadline } from 'src/assets/icons/cards/LandingPageHeadline';
import { LandingPageSubheader } from 'src/assets/icons/cards/LandingPageSubheader';
import { LinkedinAd } from 'src/assets/icons/cards/LinkedinAd';
import { LinkedinPost } from 'src/assets/icons/cards/LinkedinPost';
import { NewDocument } from 'src/assets/icons/cards/NewDocument';
import { OutbarainAdHeadline } from 'src/assets/icons/cards/OutbarainAdHeadline';
import { PAS } from 'src/assets/icons/cards/PAS';
import { PerfectProductHeadline } from 'src/assets/icons/cards/PerfectProductHeadline';
import { PinterestAd } from 'src/assets/icons/cards/PinterestAd';
import { PinterestPinDescription } from 'src/assets/icons/cards/PinterestPinDescription';
import { PinterestPinTitle } from 'src/assets/icons/cards/PinterestPinTitle';
import { ProductLandingPage } from 'src/assets/icons/cards/ProductLandingPage';
import { ProductLaunchCampaign } from 'src/assets/icons/cards/ProductLaunchCampaign';
import { ProductReview } from 'src/assets/icons/cards/ProductReview';
import { BlogWizard as ProjectsPageHeaderBlogWizard } from 'src/assets/icons/cards/projectsPageHeaderIcons/BlogWizard';
import { ContentImprover as ProjectsPageHeaderContentImprover } from 'src/assets/icons/cards/projectsPageHeaderIcons/ContentImprover';
import { NewDocument as ProjectsPageHeaderNewDocument } from 'src/assets/icons/cards/projectsPageHeaderIcons/NewDocument';
import { ProductLaunchCampaign as ProjectsPageHeaderProductLaunchCampaign } from 'src/assets/icons/cards/projectsPageHeaderIcons/ProductLaunchCampaign';
import { WelcomeEmailDrip as ProjectsPageHeaderWelcomeEmailDrip } from 'src/assets/icons/cards/projectsPageHeaderIcons/WelcomeEmailDrip';
import { PromotionalSMS } from 'src/assets/icons/cards/PromotionalSMS';
import { Prompt } from 'src/assets/icons/cards/Prompt';
import { SentenceExpander } from 'src/assets/icons/cards/SentenceExpander';
import { SEOMetaDescription } from 'src/assets/icons/cards/SEOMetaDescription';
import { Summarizer } from 'src/assets/icons/cards/Summarizer';
import { TaboolaAdHeadline } from 'src/assets/icons/cards/TaboolaAdHeadline';
import { TalkingPointsToParagraph } from 'src/assets/icons/cards/TalkingPointsToParagraph';
import { WalmartProductListings } from 'src/assets/icons/cards/WalmartProductListings';
import { WelcomeEmailDrip } from 'src/assets/icons/cards/WelcomeEmailDrip';
import { XAd } from 'src/assets/icons/cards/XAd';
import { XPost } from 'src/assets/icons/cards/XPost';
import { YoutubeVideoDescription } from 'src/assets/icons/cards/YoutubeVideoDescription';
import { YoutubeVideoTitle } from 'src/assets/icons/cards/YoutubeVideoTitle';
import { GENERATION_TOOL } from 'src/data/generationTool';

const ICONS = {
  // "basic" and "basic DD"
  [GENERATION_TOOL.basicContentImprover]: ContentImprover,
  [GENERATION_TOOL.basicEli5]: FifthGrader,
  [GENERATION_TOOL.basicSentenceExpander]: SentenceExpander,
  [GENERATION_TOOL.basicAida]: AIDA,
  [GENERATION_TOOL.basicPas]: PAS,
  [GENERATION_TOOL.basicPerfectHeadline]: PerfectProductHeadline,
  [GENERATION_TOOL.basicProductDescriptionList]: GeneralProductListing,
  [GENERATION_TOOL.basicProductDescriptionRelaxed]: GeneralProductListing,
  [GENERATION_TOOL.basicBlogIdeas]: BlogPostTopicIdes,
  [GENERATION_TOOL.basicTalkingPointsToParagraph]: TalkingPointsToParagraph,
  [GENERATION_TOOL.basicProductReview]: ProductReview,
  [GENERATION_TOOL.summarizer]: Summarizer,
  [GENERATION_TOOL.generalPrompt]: Prompt,

  // "data driven"
  [GENERATION_TOOL.facebookMixtureAd]: FacebookAd,
  [GENERATION_TOOL.facebookPrimaryTextProduct]: FacebookAd,
  [GENERATION_TOOL.facebookPrimaryTextProductRewrite]: FacebookAd,
  [GENERATION_TOOL.facebookHeadlineProduct]: FacebookAd,
  [GENERATION_TOOL.googleRSA]: GoogleRSA,
  [GENERATION_TOOL.googleDescriptionProduct]: GoogleSearchAdDescription,
  [GENERATION_TOOL.googleHeadlineProductRewrite]: GoogleSearchHeadline,
  [GENERATION_TOOL.googleDescriptionProductRewrite]: GoogleSearchAdDescription,
  [GENERATION_TOOL.googleHeadlineProduct]: GoogleSearchHeadline,
  [GENERATION_TOOL.googlePerformanceMaxAd]: GoogleSearchHeadline,
  [GENERATION_TOOL.outbrainHeadlineProduct]: OutbarainAdHeadline,
  [GENERATION_TOOL.outbrainHeadlineProductRewrite]: OutbarainAdHeadline,
  [GENERATION_TOOL.taboolaHeadlineProduct]: TaboolaAdHeadline,
  [GENERATION_TOOL.taboolaHeadlineProductRewrite]: TaboolaAdHeadline,
  [GENERATION_TOOL.twitterMixtureAd]: XAd,
  [GENERATION_TOOL.twitterCopyProduct]: XAd,
  [GENERATION_TOOL.twitterCopyProductRewrite]: XAd,
  [GENERATION_TOOL.twitterTitleProduct]: XAd,
  [GENERATION_TOOL.pinterestMixtureAd]: PinterestAd,
  [GENERATION_TOOL.pinterestDescriptionProduct]: PinterestPinDescription,
  [GENERATION_TOOL.pinterestDescriptionProductRewrite]: PinterestPinDescription,
  [GENERATION_TOOL.pinterestTitleProduct]: PinterestPinTitle,
  [GENERATION_TOOL.landingHeadline]: LandingPageHeadline,
  [GENERATION_TOOL.landingHeadlineRewrite]: LandingPageHeadline,
  [GENERATION_TOOL.landingSubheader]: LandingPageSubheader,
  [GENERATION_TOOL.landingSubheaderRewrite]: LandingPageSubheader,
  [GENERATION_TOOL.landingCTA]: LandingPageCTA,
  [GENERATION_TOOL.landingBenefits]: LandingPageBenefits,
  [GENERATION_TOOL.landingFeatures]: LandingPageFeatures,
  [GENERATION_TOOL.landingSEOMetadata]: SEOMetaDescription,
  [GENERATION_TOOL.landingSEOMetadataRewrite]: SEOMetaDescription,
  [GENERATION_TOOL.amazonProductListing]: AmazonProductListing,
  [GENERATION_TOOL.walmartProductListing]: WalmartProductListings,
  [GENERATION_TOOL.instagramCaption]: InstagramCaption,
  [GENERATION_TOOL.facebookPost]: FacebookPost,
  [GENERATION_TOOL.tweet]: XPost,
  [GENERATION_TOOL.linkedinPost]: LinkedinPost,
  [GENERATION_TOOL.linkedinPostRewrite]: LinkedinPost,
  [GENERATION_TOOL.pinterestPostDescription]: PinterestPinDescription,
  [GENERATION_TOOL.pinterestPostTitle]: PinterestPinTitle,
  [GENERATION_TOOL.youtubeTitle]: YoutubeVideoTitle,
  [GENERATION_TOOL.youtubeDescription]: YoutubeVideoDescription,
  [GENERATION_TOOL.emailSubjectLine]: EmailSubjectLine,
  [GENERATION_TOOL.emailPromotionalSubjectLine]: EmailSubjectLine,
  [GENERATION_TOOL.emailPromotionalBody]: Email,
  [GENERATION_TOOL.emailColdOutreachSubjectLine]: EmailSubjectLine,
  [GENERATION_TOOL.emailColdOutreachBody]: Email,
  [GENERATION_TOOL.emailColdOutreachBodyRewrite]: Email,
  [GENERATION_TOOL.emailPromotionalBodyRewrite]: Email,
  [GENERATION_TOOL.emailBodyRewrite]: Email,
  [GENERATION_TOOL.emailSubject]: EmailSubjectLine,
  [GENERATION_TOOL.emailBody]: Email,
  [GENERATION_TOOL.emailMixture]: Email,
  [GENERATION_TOOL.emailSubjectRewrite]: EmailSubjectLine,
  [GENERATION_TOOL.smsPromotional]: PromotionalSMS,
  [GENERATION_TOOL.smsPromotionalRewrite]: PromotionalSMS,
  [GENERATION_TOOL.facebookPrimaryTextContent]: FacebookAd,
  [GENERATION_TOOL.facebookHeadlineContent]: FacebookAd,
  [GENERATION_TOOL.outbrainHeadlineContent]: OutbarainAdHeadline,
  [GENERATION_TOOL.taboolaHeadlineContent]: TaboolaAdHeadline,
  [GENERATION_TOOL.twitterCopyContent]: XAd,
  [GENERATION_TOOL.pinterestDescriptionContent]: PinterestAd,
  [GENERATION_TOOL.pinterestTitleContent]: PinterestAd,
  [GENERATION_TOOL.generalProductListing]: GeneralProductListing,
  [GENERATION_TOOL.linkedinHeadlineSingleImageRewrite]: LinkedinAd,
  [GENERATION_TOOL.linkedinIntroSingleImageRewrite]: LinkedinAd,
  [GENERATION_TOOL.instagramCaptionRewrite]: InstagramCaption,
  [GENERATION_TOOL.facebookPostRewrite]: FacebookPost,
  [GENERATION_TOOL.pinterestPinTitleRewrite]: PinterestPinTitle,
  [GENERATION_TOOL.pinterestPinDescriptionRewrite]: PinterestPinDescription,
  [GENERATION_TOOL.tweetRewrite]: XPost,
  [GENERATION_TOOL.linkedinMixtureAd]: LinkedinAd,
  [GENERATION_TOOL.linkedinHeadlineSingleImage]: LinkedinAd,
  [GENERATION_TOOL.linkedinIntroSingleImage]: LinkedinAd,
  [GENERATION_TOOL.articleBlogHeadline]: Article,
  [GENERATION_TOOL.imageWithDescription]: ImageWithDescription,

  [GENERATION_TOOL.productLaunchMultiPrompt]: ProductLaunchCampaign,
  [GENERATION_TOOL.landingPageProductAnnouncementMultiPrompt]: ProductLandingPage,
  [GENERATION_TOOL.emailDripMultiPrompt]: WelcomeEmailDrip,

  // Freestyle
  [GENERATION_TOOL.freestyle]: Prompt,
  [GENERATION_TOOL.createYourOwn]: Prompt,

  //project blog
  [GENERATION_TOOL.blogDescription]: BlogWizard,

  [GENERATION_TOOL.lpcoLandingHeadline]: LandingPageHeadline,
  [GENERATION_TOOL.lpcoLandingCTA]: LandingPageCTA,
  new: NewDocument,
};

const PROJECT_PAGE_HEADER_ICON = {
  new: ProjectsPageHeaderNewDocument,
  [GENERATION_TOOL.basicContentImprover]: ProjectsPageHeaderContentImprover,
  [GENERATION_TOOL.productLaunchMultiPrompt]: ProjectsPageHeaderProductLaunchCampaign,
  [GENERATION_TOOL.emailDripMultiPrompt]: ProjectsPageHeaderWelcomeEmailDrip,
  [GENERATION_TOOL.blogDescription]: ProjectsPageHeaderBlogWizard,
};

export const getGenerationToolCardImage = (tool, projectsPageHeaderIcon) =>
  projectsPageHeaderIcon
    ? PROJECT_PAGE_HEADER_ICON[tool] || ICONS[tool] || Prompt
    : ICONS[tool] || Prompt;
